export const IMAGE_SMALL_WIDTH = 100
export const IMAGE_MEDIUM_WIDTH = 500
export const IMAGE_LARGE_WIDTH = 1000
